/**
 * Created by jv on 30/05/2018.
 */
import CONSTANTS from "Sources/games/chicken-game/config/constants";

import Corinne from "Sources/games/chicken-game/objects/corinne";
import Chick from "Sources/games/chicken-game/objects/chick";

export default class Coop extends Phaser.Scene
{
  constructor()
  {
    super({
      key: "Coop",
      physics:
      {
        default: "arcade",
        arcade: {
          gravity: { y: 0 },
          debug: CONSTANTS.DEBUG
        }
      }
    });

    this.corinne = null;
    this.chicks = null;

    // zone-only means you can only drop the chicks on the nest, dropping it anywhere else will put them back in their
    // previous position
    this.dropMode = CONSTANTS.DROP_MODE;

    // Calculated from center
    this.nestPosition = {
      x: 0,
      y: 55
    };

    // Calculated from center of nest
    this.corinnePosition = {
      x: 5,
      y: -70
    };

    this.chickSpawnRate = { min: 5 * 1000, max: 15 * 1000 };
    this.maxChickCount = 25;

    this.fenceBoundaries = null
    this.fenceGaps = null;

    this.spawnPositions = null;
  }

  init()
  {
    this.paused = false;

    var gameWidth = this.sys.game.config.width,
        gameHeight = this.sys.game.config.height;

    this.spawnAllowed = true;
    this.chickSpawnTimer = null;
    this.chicksOutside = 0;

    this.physics.world.setBounds(-100, -100, gameWidth + 200, gameHeight + 200);
  }

  create()
  {
    var gameWidth = this.sys.game.config.width,
        gameHeight = this.sys.game.config.height;

    // Fence
    this.fence = this.add.image(0, 0, CONSTANTS.ATLAS_KEY, "scene/fence.png").setOrigin(0).setDisplaySize(gameWidth, gameHeight).setDepth(99);
    // Create Zone
    this.createFenceZone();
    this.calculateRunToPositions();

    // Create nest
    this.nest = this.add.sprite(gameWidth / 2 + this.nestPosition.x, gameHeight / 2 + this.nestPosition.y, CONSTANTS.ATLAS_KEY, "scene/nest.png").setOrigin(0.5);
    this.calculateSpawnPositions();
    //  Drop zone for chicks
    this.chickDropZone = this.add.zone(this.nest.x, this.nest.y, this.nest.width - 10, this.nest.height - 10).setName("chick-drop-zone").setDropZone();

    // Create corinne
    this.spawnCorinne(this.nest.x + this.corinnePosition.x, this.nest.y + this.corinnePosition.y);
    this.corinne.startIdleAnimation();

    // Create chicks group
    this.chicks = this.physics.add.group({
      maxSize: this.maxChickCount,
      createCallback: (chick) =>
      {
        console.log("created chick");
      },
      removeCallback: (chick) =>
      {
        console.log("removed chick");
      }
    });

    // Add colliders
    // let chicks collide with each other
    this.physics.add.collider(this.chicks, this.chicks, null, null, this);
    this.physics.add.overlap(this.chicks, this.fenceZone, this.onChickFenceCollide, null, this);
    this.physics.add.overlap(this.chicks, this.coopZone, this.onChickGrassCollide, null, this);

    // Add drag event listener
    this.setUpDragListener();

    // Start chick spawning
    this.spawnChick();

    if(CONSTANTS.DEBUG)
    {
      this.debugGraphics = this.add.graphics();
      this.debugGraphics.lineStyle(1, 0xff0000, 1);

      this.debugGraphics.strokeRectShape(this.nest.getBounds());

      this.debugGraphics.lineStyle(2, 0xffff00);
      this.debugGraphics.strokeRect(this.chickDropZone.x + this.chickDropZone.input.hitArea.x, this.chickDropZone.y + this.chickDropZone.input.hitArea.y, this.chickDropZone.input.hitArea.width, this.chickDropZone.input.hitArea.height);
    }
  }

  createFenceZone()
  {
    this.fenceZone = this.physics.add.group({ immovable: true });
    this.coopZone = this.physics.add.group({ immovable: true });

    this.fenceBoundaries = {
      x: this.fence.frame.x + 20,
      y: this.fence.frame.y + 40,
      width: this.fence.frame.width - 45,
      height: this.fence.frame.height - 50
    };

    var chickFrame = this.scene.systems.game.textures.getFrame(CONSTANTS.ATLAS_KEY, "animations/chicks/run/n/0001.png");

    this.grassBoundaries = {
      x: this.fence.frame.x + 50 - (chickFrame.width / 2),
      y: this.fence.frame.y + 70 - (chickFrame.height / 2),
      width: this.fence.frame.width - 100 + (chickFrame.width),
      height: this.fence.frame.height - 80 + (chickFrame.width)
    };

    // TOP
    this.createFenceBoundary(this.fenceZone, "fence-top", this.fenceBoundaries.x, this.fenceBoundaries.y, this.fenceBoundaries.width, 1);
    // LEFT
    this.createFenceBoundary(this.fenceZone, "fence-left", this.fenceBoundaries.x, this.fenceBoundaries.y, 1, this.fenceBoundaries.height);
    // BOTTOM
    this.createFenceBoundary(this.fenceZone, "fence-bottom", this.fenceBoundaries.x, this.fenceBoundaries.y + this.fenceBoundaries.height, this.fenceBoundaries.width, 1);
    // RIGHT
    this.createFenceBoundary(this.fenceZone, "fence-right", this.fenceBoundaries.x + this.fenceBoundaries.width, this.fenceBoundaries.y, 1, this.fenceBoundaries.height);

    // TOP
    this.createFenceBoundary(this.coopZone, "coop-boundary-top", this.grassBoundaries.x, this.grassBoundaries.y, this.grassBoundaries.width, 1);
    // LEFT
    this.createFenceBoundary(this.coopZone, "coop-boundary-left", this.grassBoundaries.x, this.grassBoundaries.y, 1, this.grassBoundaries.height);
    // BOTTOM
    this.createFenceBoundary(this.coopZone, "coop-boundary-bottom", this.grassBoundaries.x, this.grassBoundaries.y + this.grassBoundaries.height, this.grassBoundaries.width, 1);
    // RIGHT
    this.createFenceBoundary(this.coopZone, "coop-boundary-right", this.grassBoundaries.x + this.grassBoundaries.width, this.grassBoundaries.y, 1, this.grassBoundaries.height);
  }

  createFenceBoundary(group, name, x, y, width, height)
  {
    var fenceBoundary = this.add.zone(x, y, width, height);
    fenceBoundary.setName(name);
    group.add(fenceBoundary);
  }

  setUpDragListener()
  {
    this.input.off("drag").on("drag", (pointer, chick, dragX, dragY) =>
    {
      if(chick instanceof Chick && this.chicksOutside === 0)
      {
        chick.x = dragX;
        chick.y = dragY;
      }
    });

    this.input.off("dragstart").on("dragstart", (pointer, chick) =>
    {
      if(chick instanceof Chick && this.chicksOutside === 0)
      {
        if(this.dropMode === CONSTANTS.DROP_MODES.ZONE_ONLY)
        {
          chick.pauseRunning();
        }
        else
        {
          chick.stopRunning();
        }
      }
    });

    this.input.off("dragend").on("dragend", (pointer, chick) =>
    {
      if(chick instanceof Chick && this.chicksOutside === 0)
      {
        if(this.dropMode === CONSTANTS.DROP_MODES.ZONE_ONLY)
        {
          chick.resumeRunning();
        }
        else
        {
          chick.stopRunning();

          var runToPos = this.getRandomRunToPosition(chick.x, chick.y);
          chick.runTo(runToPos.x, runToPos.y);
        }
      }
    });

    this.input.off("drop").on("drop", (pointer, chick, dropZone) =>
    {
      if(chick instanceof Chick && dropZone.name === "chick-drop-zone" && this.chicksOutside === 0)
      {
        chick.stopRunning();

        var spawnPosition = this.getRandomSpawnPosition(chick.hatchPosition);

        chick.x = spawnPosition.x;
        chick.y = spawnPosition.y;

        var runToPos = this.getRandomRunToPosition(chick.x, chick.y);
        chick.runTo(runToPos.x, runToPos.y);
      }
    });
  }

  update(time)
  {
    if(!this.paused)
    {

    }
  }

  get paused()
  {
    return this._paused;
  }

  set paused(paused)
  {
    this._paused = paused;

    this.pauseTimers(this.paused);
    this.pauseAnimations(this.paused);
    this.pauseChicks(this.paused);
    this.spawnAllowed = !this.paused;

    if(this.paused)
    {
      this.physics.pause();
    }
    else
    {
      this.physics.resume();
    }
  }

  pauseAnimations(flag)
  {
    if(this.corinne !== null)
    {
      this.pauseAnimation(this.corinne.sprite, flag);
    }
  }

  pauseAnimation(sprite, flag)
  {
    if(sprite !== null)
    {
      if(flag)
      {
        sprite.anims.stop();
      }
      else
      {
        sprite.anims.play();
      }
    }
  }

  pauseChicks(flag)
  {
    if(this.chicks !== null)
    {
      this.chicks.children.iterate((chick) =>
      {
        // Let escaped chicks keep running
        if(!chick.escaped)
        {
          this.pauseAnimation(chick, flag);

          if(flag)
          {
            chick.pauseRunning();
          }
          else
          {
            chick.resumeRunning();
          }
        }
      });
    }
  }

  pauseTimers(flag)
  {
    this.pauseTimer(this.chickSpawnTimer, flag);
  }

  pauseTimer(timer, flag)
  {
    if(timer)
    {
      timer.paused = flag;
    }
  }

  clearCoop()
  {
    this.corinne.destroy();
    this.chicks.clear(true, true);
  }

  calculateRunToPositions()
  {
    var fenceWidth = this.fenceBoundaries.width,
        fenceHeight = this.fenceBoundaries.height;
    var fenceSides = [ "top", "right", "bottom", "left" ];

    this.fenceGaps = {};

    var lengthGaps = 4;
    var lengthSpacing = fenceWidth / (lengthGaps + 1);
    var heightGaps = 3;
    var heightSpacing = fenceHeight / (heightGaps + 1);

    // Corners are only added on 1 side (top and bottom)
    // Sides currently don't really matter but adding corners to left and right as well means they'll have a higher
    // chance to be picked over the other positions.

    for(var i = 0; i < fenceSides.length; i++)
    {
      var x = this.fenceBoundaries.x;
      // var x = this.fenceBoundaries.x + lengthSpacing;
      var top = this.fenceBoundaries.y;
      var bottom = this.fenceBoundaries.y + this.fenceBoundaries.height;

      // var y = this.fenceBoundaries.y;
      var y = this.fenceBoundaries.y + heightSpacing;
      var left = this.fenceBoundaries.x;
      var right = this.fenceBoundaries.x + this.fenceBoundaries.width;

      // +2 for the corners
      var gaps = fenceSides[i] === "top" || fenceSides[i] === "bottom" ? lengthGaps + 2 : heightGaps;

      var fenceGapsForSide = [];

      for(var j = 0; j < gaps; j++)
      {
        if(fenceSides[i] === "top")
        {
          fenceGapsForSide.push({ x, y: top });
        }
        else if(fenceSides[i] === "bottom")
        {
          fenceGapsForSide.push({ x, y: bottom });
        }
        else if(fenceSides[i] === "left")
        {
          fenceGapsForSide.push({ x: left, y });
        }
        else if(fenceSides[i] === "right")
        {
          fenceGapsForSide.push({ x: right, y });
        }

        x += lengthSpacing;
        y += heightSpacing;
      }

      this.fenceGaps[fenceSides[i]] = fenceGapsForSide;
    }

    if(CONSTANTS.DEBUG)
    {
      var graphics = this.add.graphics();
      graphics.setDepth(999);
      graphics.lineStyle(2, 0x00ffff, 1);

      graphics.beginPath();

      for(var side in this.fenceGaps)
      {
        if(this.fenceGaps.hasOwnProperty(side))
        {
          for(var i = 0; i < this.fenceGaps[side].length; i++)
          {
            graphics.strokeCircle(this.fenceGaps[side][i].x, this.fenceGaps[side][i].y, 10);
          }
        }
      }

      // graphics.moveTo(this.fenceGaps.top[i].x, this.fenceGaps.top[i].y);
      // graphics.lineTo(this.fenceGaps.bottom[i].x, this.fenceGaps.bottom[i].y);
      // graphics.strokePath();

      graphics.closePath();
    }
  }

  calculateSpawnPositions()
  {
    this.spawnPositions = {
      top: [
        { x: this.nest.x, y: this.nest.y - 40 }
      ],
      left: [
        { x: this.nest.x - 40, y: this.nest.y - 30 },
        { x: this.nest.x - 50, y: this.nest.y },
        { x: this.nest.x - 40, y: this.nest.y + 30 }
      ],
      bottom: [
        { x: this.nest.x, y: this.nest.y + 40 }
      ],
      right: [
        { x: this.nest.x + 40, y: this.nest.y - 30 },
        { x: this.nest.x + 50, y: this.nest.y },
        { x: this.nest.x + 40, y: this.nest.y + 30 }
      ]
    };

    if(CONSTANTS.DEBUG)
    {
      var graphics = this.add.graphics();
      graphics.setDepth(999);
      graphics.lineStyle(2, 0x00ffff, 1);

      graphics.beginPath();

      for(var side in this.spawnPositions)
      {
        if(this.spawnPositions.hasOwnProperty(side))
        {
          for(var i = 0; i < this.spawnPositions[side].length; i++)
          {
            graphics.strokeCircle(this.spawnPositions[side][i].x, this.spawnPositions[side][i].y, 5);
          }
        }
      }

      graphics.closePath();
    }
  }

  getRandomRunToPosition(x, y)
  {
    var positions = [];

    for(var side in this.fenceGaps)
    {
      if(this.fenceGaps.hasOwnProperty(side))// && sides === null || sides.includes(side))
      {
        for(var i = 0; i < this.fenceGaps[side].length; i++)
        {
          var pos = this.fenceGaps[side][i];

          if((x >= this.nest.x && pos.x >= this.nest.x) || (x <= this.nest.x && pos.x <= this.nest.x))
          {
            if((y >= this.nest.y && pos.y >= this.nest.y) || (y <= this.nest.y && pos.y <= this.nest.y))
            {
              positions.push(pos);
            }
          }
        }
      }
    }

    var randomIndex = Phaser.Math.Between(0, positions.length - 1);
    return positions[randomIndex];
  }

  spawnCorinne(x = 0, y = x)
  {
    if(this.corinne !== null)
    {
      this.corinne.destroy();
    }

    this.corinne = new Corinne(this, x, y);

    // http://labs.phaser.io/index.html?dir=depth%20sorting/&q=
    // this.corinne.sprite.setDepth(79);
    this.corinne.sprite.setDepth(99);

    return this.corinne;
  }

  spawnChick()
  {
    if(this.spawnAllowed)
    {
      this.chickSpawnTimer = null;
      const chickCount = this.chicks.children.size;

      if(chickCount < this.maxChickCount)
      {
        const _chick = this.createChick();
        _chick.hatch();

        // Maybe check overlap with other chicks?
      }

      this.queueChick(Phaser.Math.Between(this.chickSpawnRate.min, this.chickSpawnRate.max));
    }
  }

  queueChick(time)
  {
    if(this.chickSpawnTimer === null)
    {
      this.chickSpawnTimer = this.time.addEvent({ delay: time, callback: this.spawnChick, callbackScope: this, loop: false });
    }
  }

  createChick()
  {
    var position = CONSTANTS.CHICK_HATCH_POSITIONS[Phaser.Math.Between(0, CONSTANTS.CHICK_HATCH_POSITIONS.length - 1)];;

    var spawnPosition = this.getRandomSpawnPosition(position);

    var _chick = new Chick(this, {
      x: spawnPosition.x,
      y: spawnPosition.y,
      hatchPosition: position,
      onHatch: (chick) =>
      {
        var runToPos = this.getRandomRunToPosition(chick.spawnPosition.x, chick.spawnPosition.y);
        chick.runTo(runToPos.x, runToPos.y);
      }
    });

    this.sys.displayList.add(_chick);
    this.sys.updateList.add(_chick);
    this.physics.world.enableBody(_chick);

    this.chicks.add(_chick);
    _chick.setDepth(89);

    _chick.body.allowGravity = false;
    _chick.setBounce(0);
    _chick.setCollideWorldBounds(true);
    // _chick.body.setImmovable(true);

    _chick.setInteractive();
    this.input.setDraggable(_chick);

    return _chick;
  }

  getRandomSpawnPosition(side)
  {
    if(this.spawnPositions.hasOwnProperty(side))
    {
      return this.spawnPositions[side][Phaser.Math.Between(0, this.spawnPositions[side].length - 1)];
    }

    return null;
  }

  onChickGrassCollide(chick, fence)
  {
    if(chick.escaped)
    {
      return;
    }

    this.chicksOutside++;
    chick.escaped = true;
    chick.flash();

    this.events.emit("chick-escaped", chick);
  }

  onChickFenceCollide(chick, fence)
  {
    if(chick.runningOutside)
    {
      return;
    }

    var gameWidth = this.sys.game.config.width,
        gameHeight = this.sys.game.config.height;
    chick.stopRunning();

    chick.runningOutside = true;

    if(fence.name === "fence-top")
    {
      chick.runTo(chick.x, -100, 2000);
    }
    else if(fence.name === "fence-left")
    {
      chick.runTo(-100, chick.y, 3000);
    }
    else if(fence.name === "fence-bottom")
    {
      chick.runTo(chick.x, gameHeight + 100, 2000);
    }
    else if(fence.name === "fence-right")
    {
      chick.runTo(gameWidth + 100, chick.y, 3000);
    }
  }
}



// WEBPACK FOOTER //
// ./app/js/games/chicken-game/scenes/coop.js